<template>
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <nav id="breadcrumbs" class="mb-3">
          <ul>
            <li>
              <router-link :to="{ name: 'company.dashboard' }">
                <i class="uil-home-alt"></i>
              </router-link>
            </li>
            <li>{{ this.$t('general.manage_menu_modules') }}</li>
          </ul>
        </nav>
      </div>

      <div v-if="successMessage" class="uk-alert-success" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p style="color: green">
          <i class="uil-exclamation-triangle"></i> {{ successMessage }}
        </p>
      </div>
      <div v-show="errorMessage" class="uk-alert-danger" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p style="color: red">
          <i class="uil-exclamation-triangle"></i> {{ errorMessage }}
        </p>
      </div>

      <default-loading v-if="loading"></default-loading>
      <template v-else>
        <div class="card">
          <!-- Card header -->
          <div class="card-header actions-toolbar border-0">
            <div class="row">
              <div class="col-12 mb-3">
                <multiple-select-input
                    v-model="selectedCompany"
                    :allowEmpty="true"
                    :multiple="false"
                    :required="false"
                    :searchable="companyList.length > 10"
                    :showLabels="false"
                    :values="companyList"
                    :title="$t('general.add_institue')"
                    label="name"
                    track-by="id"
                    @select="onCompanySelect"
                />
              </div>

              <div v-if="companyId" class="col-12">

                <div class="d-flex justify-content-between align-items-center">
                  <h4 class="mb-3 mt-3"><i class="uil-th"></i> {{ this.$t('general.manage_modules') }}</h4>
                </div>

                <draggable :list="moduleList?.menu" class="uk-accordion-content mt-0" group="education_widget">
                  <div v-for="(module, index) in moduleList?.menu" :key="'assignment_content_list_' + index">
                    <div class="sec-list-item">
                      <div style="width:100%">
                        <i class="uil-list-ul mr-2"></i>
                        <!-- <p>{{ module.title }}</p> -->
                        <p style="width:92%;margin-bottom:-14px">
                          <input :value="getModuleDisplayTitle(module)" class="module-title-input" name="title"
                                 readonly type="text"/>
                        </p>
                        <i v-if="module.type === 'my-assignment'" :uk-tooltip="getModuleTooltipConfig(module)"
                           class="uil-book-open"
                           style="margin-left:1.5rem">
                        </i>

                        <i v-if="module.type === 'my-statistics'" :uk-tooltip="getModuleTooltipConfig(module)"
                           class="uil-chart-line"
                           style="margin-left:1.5rem">
                        </i>

                        <i v-if="['my_competency', 'my-development'].includes(module.type)"
                           :uk-tooltip="getModuleTooltipConfig(module)"
                           class="uil-chart-growth"
                           style="margin-left:1.5rem">
                        </i>

                        <i v-if="['my_team', 'my-team'].includes(module.type)"
                           :uk-tooltip="getModuleTooltipConfig(module)"
                           class="uil-users-alt"
                           style="margin-left:1.5rem">
                        </i>

                        <i v-if="module.type === 'my-collection'" :uk-tooltip="getModuleTooltipConfig(module)"
                           class="uil-notebooks"
                           style="margin-left:1.5rem">
                        </i>

                        <i v-if="module.type === 'education-category'" :uk-tooltip="getModuleTooltipConfig(module)"
                           class="uil-books"
                           style="margin-left:1.5rem">
                        </i>

                        <i v-if="module.type === 'gift'" :uk-tooltip="getModuleTooltipConfig(module)" class="uil-gift"
                           style="margin-left:1.5rem">
                        </i>

                        <i v-if="module.type === 'wall'" :uk-tooltip="getModuleTooltipConfig(module)" class="uil-coffee"
                           style="margin-left:1.5rem">
                        </i>

                        <i v-if="module.type === 'agenda'" :uk-tooltip="getModuleTooltipConfig(module)"
                           class="uil-calendar-alt"
                           style="margin-left:1.5rem"></i>

                        <i v-if="module.type === 'solution_partners_apps'" :uk-tooltip="getModuleTooltipConfig(module)"
                           class="uil-heart"
                           style="margin-left:1.5rem"></i>
                        <a :uk-tooltip="`title: ${$t('faq_categories.edit')}; pos: bottom; offset: 0`"
                           class="btn btn-icon btn-hover btn-sm btn-circle ml-2 module-edit-icon-btn"
                           href="javascript:void(0)"
                           @click="openLangTitleModal(module)">
                          <i class="uil-pen"></i>
                        </a>
                      </div>
                      <div>
                        <div class="btn-act">
                          <label class="uk-switch">
                            <input v-model="module.status" type="checkbox"/>
                            <div class="uk-switch-slider"></div>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </draggable>
                <hr>

                <div class="d-flex justify-content-between align-items-center">
                  <h4 class="mt-3 mb-3"><i class="uil-window-section"></i> {{ $t('general.home_page_management') }}
                  </h4>
                  <button class="btn btn-sm btn-default"
                          type="button"
                          @click="openAddDashboardModal">
                    <i class="uil-plus"></i> {{ $t('general.add_menu') }}
                  </button>
                </div>
                <draggable :list="moduleList.dashboard" class="uk-accordion-content mt-0" group="education_widget">
                  <div v-for="(module, index) in moduleList.dashboard" :key="'assignment_content_list_' + index">
                    <div class="sec-list-item">
                      <div style="width:100%">
                        <i class="uil-list-ul mr-2"></i>
                        <p style="width:92%;margin-bottom:-14px">
                          <input :value="getModuleDisplayTitle(module)" class="module-title-input" name="title"
                                 readonly type="text"/>
                        </p>
                        <i :uk-tooltip="getModuleTooltipConfig(module)" class="uil-info-circle"
                           style="margin-left:1.5rem">
                        </i>
                        <a :uk-tooltip="`title: ${$t('faq_categories.edit')}; pos: bottom; offset: 0`"
                           class="btn btn-icon btn-hover btn-sm btn-circle ml-2 module-edit-icon-btn"
                           href="javascript:void(0)"
                           @click="openLangTitleModal(module)">
                          <i class="uil-pen"></i>
                        </a>
                      </div>
                      <div>
                        <div class="btn-act d-flex align-items-center">
                          <a v-if="module.widgetable_type"
                             :uk-tooltip="`title: ${$t('general.delete')}; pos: bottom; offset: 0`"
                             class="btn btn-icon btn-hover btn-sm btn-circle mr-2 module-edit-icon-btn"
                             href="javascript:void(0)"
                             @click="deleteDashboardWidget(module)">
                            <i class="uil-trash-alt text-danger"></i>
                          </a>
                          <label class="uk-switch">
                            <input v-model="module.status" type="checkbox"/>
                            <div class="uk-switch-slider"></div>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </draggable>
              </div>
            </div>
          </div>
          <div class="uk-flex uk-flex-right p-4">
            <button class="btn btn-default" type="button" @click="save">
              {{ $t("general.save") }}
            </button>
          </div>
        </div>
      </template>
    </div>
    <div id="module-lang-title-modal" ref="langTitleModal" class="uk-modal-container" uk-modal>
      <div class="uk-modal-dialog uk-modal-body">
        <h4 class="uk-modal-title">
          {{ $t('faq_categories.edit') }}:
          {{ selectedModuleForLang ? getModuleDisplayTitle(selectedModuleForLang) : '' }}
        </h4>

        <div class="row mt-3">
          <div v-for="lang in langOptions" :key="lang.code" class="col-md-6 mb-3">
            <label class="col-form-label">
              {{ lang.name }} ({{ lang.code }})
            </label>
            <input v-model="langTitleForm[lang.code]"
                   class="form-control"
                   type="text"
            />
          </div>
        </div>

        <p class="uk-text-right mt-4">
          <button class="btn btn-light mr-2" type="button" @click="closeLangTitleModal">
            {{ $t("general.close") }}
          </button>
          <button class="btn btn-default" type="button" @click="applyLangTitleChanges">
            {{ $t("general.apply") }}
          </button>
        </p>
      </div>
    </div>

    <AddDashboardModal ref="addDashboardModal"
                       :lang-options="langOptions"
                       :widgetable-options="widgetableOptions"
                       @submit="submitAddDashboard"
    />
  </div>
</template>

<script>
import draggable from "vuedraggable";
import DataTable from "@/assets/components/dataTable/DataTable";
import axios from "axios";
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import SecureLS from "secure-ls";
import i18nService from "@/core/services/i18n.service";
import { confirmDialogDelete } from "@/utils/confirmDialog";
import AddDashboardModal from "./components/AddDashboardModal";

const ls = new SecureLS({ encodingType: 'aes', isCompression: true });
export default {
  name: "ModuleList",
  components: { DataTable, MultipleSelectInput, DefaultLoading, draggable, AddDashboardModal },
  data() {
    return {
      repeatable: false,
      errorMessage: null,
      successMessage: null,
      companyList: [],
      selectedCompany: null,
      loading: true,
      moduleList: {},
      modules: [],
      headers: this.apiHeaders,
      selectedModuleForLang: null,
      langTitleForm: {},
      langOptions: [],
      onLangTitleModalHidden: null,
      widgetableOptions: [
        { value: 'assignment', label: 'Assignment' }
      ],
    };
  },
  computed: {
    companyId() {
      return this.selectedCompany ? this.selectedCompany.id : null;
    },
    activeLanguageCode() {
      return String((this.$i18n && this.$i18n.locale) || this.secureLocalStorage("language") || "tr").toLowerCase();
    },
  },
  methods: {
    onCompanySelect(value) {
      this.selectedCompany = value;
      this.getCompanyModule();
    },
    save() {
      let self = this;
      let sendData = [];

      this.moduleList['dashboard'].forEach((element, index) => {
        sendData.push({
          group_name: 'dashboard',
          type: element.type,
          title: element.title,
          order: index,
          status: element.status,
          lang_title: this.normalizeLangTitleForPayload(element.lang_title)
        })
      });
      this.moduleList['menu'].forEach((element, index) => {
        sendData.push({
          group_name: 'menu',
          type: element.type,
          title: element.title,
          order: index,
          status: element.status,
          lang_title: this.normalizeLangTitleForPayload(element.lang_title)
        })
      });

      axios.post(process.env.VUE_APP_BACKEND_APP_URL + "/api/widgets", {
        params: {
          company_id: self.companyId,
          widgets: sendData
        },
      })
          .then((response) => {
            if (response['status'] === 200) {
              let menu = [];
              let dashboard = [];
              response?.data.forEach(element => {
                if (element.group_name === 'menu') {
                  menu.push(element)
                } else if (element.group_name === 'dashboard') {
                  dashboard.push(element)
                }
              });
              let test = {
                'menu': menu,
                'dashboard': dashboard
              }
              this.moduleList = test
              this.ensureLangOptionsFromModules();
              ls.set("dashboardMenuList", test)
              // window.localStorage.setItem("moduleList", test);
              self.successMessage = this.$t("general.update_success");
            } else {
              self.errorMessage = this.$t("errors.500");
            }
            window.scrollTo(0, 0);
          });
    },

    getCompanies() {
      let self = this;
      axios
          .get(process.env.VUE_APP_BACKEND_APP_URL + "/api/get-companies", {
            headers: this.apiHeaders,
          })
          .then((response) => {
            let items = response.data;
            items.forEach((item) => {
              self.companyList.push({
                id: item.id,
                name: item.name,
              });
              self.loading = false
            });
          });
    },
    mergeModuleChanges(fetchedModules, currentModules) {
      const merged = { ...fetchedModules };
      const moduleKey = module => module.widgetable_type
          ? `widget:${module.widgetable_type}:${module.id}`
          : `type:${module.type}`;

      ["dashboard", "menu"].forEach(groupName => {
        const remaining = new Map(
            (fetchedModules[groupName] || []).map(module => [moduleKey(module), module])
        );
        const modules = [];

        (currentModules[groupName] || []).forEach(module => {
          const key = moduleKey(module);
          const fetched = remaining.get(key);
          if (!fetched) return;

          const edits = {
            title: module.title,
            lang_title: module.lang_title,
            status: module.status,
          };
          Object.keys(fetched).forEach(field => this.$set(module, field, fetched[field]));
          Object.keys(edits).forEach(field => this.$set(module, field, edits[field]));
          modules.push(module);
          remaining.delete(key);
        });

        merged[groupName] = [...modules, ...remaining.values()];
      });

      return merged;
    },
    getCompanyModule(preserveChanges = false) {
      let self = this;
      this.modules = [];
      const companyId = this.companyId;

      return axios.get(process.env.VUE_APP_BACKEND_APP_URL + "/api/widgets", {
        params: {
          company_id: self.companyId
        },
      })
          .then((response) => {
            if (this.companyId !== companyId) return;
            this.moduleList = preserveChanges
                ? this.mergeModuleChanges(response.data, this.moduleList)
                : response.data;
            this.ensureLangOptionsFromModules();
          });
    },
    parseStoredLanguages() {
      const rawLanguages = ls.get("xlanguages");
      if (!rawLanguages) {
        return [];
      }

      try {
        const parsed = typeof rawLanguages === "string" ? JSON.parse(rawLanguages) : rawLanguages;
        if (!Array.isArray(parsed)) {
          return [];
        }

        return parsed.filter(item => item && item.code).map(item => ({
          code: String(item.code).toLowerCase(),
          name: item.name || String(item.code).toUpperCase(),
        }));
      } catch (e) {
        return [];
      }
    },
    ensureLangOptionsFromModules() {
      const fromStorage = this.parseStoredLanguages();
      const map = {};

      fromStorage.forEach(item => {
        map[item.code] = item;
      });

      ["dashboard", "menu"].forEach(groupName => {
        const list = this.moduleList[groupName] || [];
        list.forEach(module => {
          if (!module || !module.lang_title || typeof module.lang_title !== "object") {
            return;
          }
          Object.keys(module.lang_title).forEach(code => {
            const normalizedCode = String(code).toLowerCase();
            if (!map[normalizedCode]) {
              map[normalizedCode] = {
                code: normalizedCode,
                name: normalizedCode.toUpperCase(),
              };
            }
          });
        });
      });

      if (!Object.keys(map).length) {
        (i18nService.languages || []).forEach(language => {
          const code = String(language.lang || "").toLowerCase();
          if (!code) {
            return;
          }
          map[code] = {
            code,
            name: language.name || code.toUpperCase(),
          };
        });
      }

      this.langOptions = Object.values(map);
    },
    openLangTitleModal(module) {
      this.selectedModuleForLang = module;
      const formData = {};

      this.langOptions.forEach(lang => {
        const existingValue = module?.lang_title && module.lang_title[lang.code];
        formData[lang.code] = existingValue !== undefined && existingValue !== null ? String(existingValue) : "";
      });

      if (module?.lang_title && typeof module.lang_title === "object") {
        Object.keys(module.lang_title).forEach(code => {
          if (formData[code] === undefined) {
            formData[code] = module.lang_title[code] !== null && module.lang_title[code] !== undefined
                ? String(module.lang_title[code])
                : "";
          }
        });
      }

      this.langTitleForm = formData;
      this.$nextTick(() => {
        const modal = UIkit.modal(this.$refs.langTitleModal);
        if (modal) {
          modal.show();
        }
      });
    },
    resetLangTitleModalState() {
      this.selectedModuleForLang = null;
      this.langTitleForm = {};
    },
    closeLangTitleModal() {
      const modal = UIkit.modal(this.$refs.langTitleModal);
      if (modal) {
        modal.hide();
      }
    },
    applyLangTitleChanges() {
      if (!this.selectedModuleForLang) {
        return;
      }

      const updated = {};
      Object.keys(this.langTitleForm).forEach(code => {
        const value = (this.langTitleForm[code] || "").trim();
        if (value !== "") {
          updated[code] = value;
        }
      });

      this.$set(this.selectedModuleForLang, "lang_title", Object.keys(updated).length ? updated : null);
      this.closeLangTitleModal();
    },
    normalizeLangTitleForPayload(langTitle) {
      if (!langTitle || typeof langTitle !== "object") {
        return null;
      }

      const normalized = {};
      Object.keys(langTitle).forEach(code => {
        if (langTitle[code] === null || langTitle[code] === undefined) {
          return;
        }
        const value = String(langTitle[code]).trim();
        if (value !== "") {
          normalized[code] = value;
        }
      });

      return Object.keys(normalized).length ? normalized : null;
    },
    getModuleDisplayTitle(module) {
      if (!module) {
        return "";
      }

      const langTitle = module.lang_title && typeof module.lang_title === "object" ? module.lang_title : null;
      if (langTitle) {
        const code = this.activeLanguageCode;
        const localized =
            langTitle[code] ??
            langTitle[code.toLowerCase()] ??
            langTitle[code.toUpperCase()];

        if (localized !== undefined && localized !== null && String(localized).trim() !== "") {
          return String(localized);
        }
      }

      if (module.type_lang && String(module.type_lang).trim() !== "") {
        return String(module.type_lang);
      }

      return module.title || "";
    },
    getModuleTooltipConfig(module) {
      const title = module?.type_lang ? String(module.type_lang) : "";

      return `title: ${title}; pos: bottom; offset: 0`;
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
    openAddDashboardModal() {
      this.$refs.addDashboardModal.open();
    },
    async deleteDashboardWidget(module) {
      const isConfirmed = await confirmDialogDelete({ context: this });
      if (!isConfirmed) return;

      const widgetable = module.widgetable_type;
      const widgetManagementId = module.id;

      axios.delete(
          `${process.env.VUE_APP_BACKEND_APP_URL}/api/widgets/${widgetable}/${widgetManagementId}`
      )
          .then((response) => {
            if (response.status === 200 || response.status === 204) {
              this.successMessage = this.$t("general.successfully_deleted");
              this.getCompanyModule(true);
            } else {
              this.errorMessage = this.$t("errors.500");
            }
            window.scrollTo(0, 0);
          })
          .catch((error) => {
            this.errorMessage = error.response?.data?.message || this.$t("errors.500");
            window.scrollTo(0, 0);
          });
    },
    submitAddDashboard(formData) {
      const widgetable = formData.widgetable;

      const payload = {
        title: formData.title,
        type: widgetable,
        lang_title: this.normalizeLangTitleForPayload(formData.lang_title),
        status: 1
      };

      axios.post(
          `${process.env.VUE_APP_BACKEND_APP_URL}/api/widgets/${widgetable}/store`,
          payload,
          {
            headers: this.apiHeaders,
            params: {
              company_id: this.companyId
            }
          }
      )
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              this.successMessage = this.$t("general.dashboard_added_successfully");
              this.$refs.addDashboardModal.close();
              this.getCompanyModule(true);
            } else {
              this.errorMessage = this.$t("errors.500");
            }
            window.scrollTo(0, 0);
          })
          .catch((error) => {
            this.errorMessage = error.response?.data?.message || this.$t("errors.500");
            window.scrollTo(0, 0);
          });
    },
  },
  mounted() {
    this.getCompanies();
    this.langOptions = this.parseStoredLanguages();
    if (!this.langOptions.length) {
      this.langOptions = (i18nService.languages || [])
          .map(language => ({
            code: String(language.lang || "").toLowerCase(),
            name: language.name || String(language.lang || "").toUpperCase(),
          }))
          .filter(language => language.code);
    }

    if (this.$refs.langTitleModal) {
      this.onLangTitleModalHidden = event => {
        if (event.target === this.$refs.langTitleModal) {
          this.resetLangTitleModalState();
        }
      };
      this.$refs.langTitleModal.addEventListener("hidden", this.onLangTitleModalHidden);
    }
  },
  beforeDestroy() {
    if (this.$refs.langTitleModal && this.onLangTitleModalHidden) {
      this.$refs.langTitleModal.removeEventListener("hidden", this.onLangTitleModalHidden);
    }
  },
  watch: {
    errors: function (val) {
      if (val) {
        this.scrollToTop();
        this.errorMessages.push(val);
      }
    },
    successMessage: function (val) {
      this.debouncedResetValues();
    },
    errorMessages: function (val) {
      this.debouncedResetValues();
    },
    '$i18n.locale'() {
      if (this.companyId) {
        this.getCompanyModule(true);
      }
    },
  },
  created: function () {
    this.debouncedResetValues = _.debounce(this.resetMessages, 5000);
  },
};
</script>
<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.form-group.list input[type="number"] {
  padding: 15px 0 15px 10px !important;
}

input[type="number"]:focus {
  border: 1px solid #e2e5ec !important;
}

.module-title-input {
  pointer-events: none;
  cursor: default;
  caret-color: transparent;
}

.module-edit-icon-btn {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}

.module-edit-icon-btn i {
  line-height: 1;
}
</style>

<style>
.multiselect__tag {
  color: white;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: #3e416d;
}

.multiselect__tag-icon {
  background-color: transparent;
  line-height: 2.2;
}

.multiselect__tag-icon:after {
  color: #fff;
}

.multiselect__tag-icon:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.multiselect__input {
  border: unset !important;
}

.multiselect__tags .multiselect__input {
  border: unset !important;
}

#module-lang-title-modal .uk-modal-dialog {
  max-width: 680px !important;
}

</style>
